"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionContext = void 0;
exports.useConnection = useConnection;
var errors_1 = require("@hermis/errors");
var react_1 = require("react");
/**
 * Context for connection functionality
 */
exports.ConnectionContext = (0, react_1.createContext)({});
/**
 * Hook for accessing Solana connection
 *
 * Returns a connection that can be either legacy or Kit architecture.
 * The connection will work with all dual architecture transaction methods.
 *
 * @returns ConnectionContextState with DualConnection
 */
function useConnection() {
    var connectionContext = (0, react_1.useContext)(exports.ConnectionContext);
    if (connectionContext === undefined) {
        throw new errors_1.HermisError(errors_1.HERMIS_ERROR__REACT__CONTEXT_NOT_FOUND, { hookName: 'useConnection', providerName: 'ConnectionProvider' });
    }
    return connectionContext;
}
